import { css } from '@emotion/react'
import { Block } from 'components/Block'
import { GroupLifeSignupForm } from 'components/groupLifeSection/signup/Form'
import { SList, SListItem, SWrapper } from './Signup.styled'
import { BlankTopNavigation } from 'components/header/topNavigationLandingPage/BlankTopNavigation'
import { Icon } from 'components/icon'
import { IconWrapper } from 'components/iconWrapper/IconWrapper'
import { Layout } from 'components/layout/Layout'
import { HStack, Stack } from 'components/Stack'
import { useGroupLifeEnabled } from 'logic/subscription/plan/groupLife/useGroupLifeEnabled'
import { isGroupLifeAvailable } from 'logic/subscription/plan/groupLife/isGroupLifeAvailable'
import { Caption, Text, Title, Title_h1_default } from 'components/Typography'

import AmalgamatedAgencyLogo from 'images/extra-svg/AmalgamatedAgency.svg'
import { useTranslation } from 'next-i18next'
import { events } from 'utils/analytics'
import { colors } from 'utils/colors'
import { formatPrice } from 'utils/format'
import { useRunOnceReady } from 'utils/hooks'

export function GroupLifeSignup() {
  useGroupLifeEnabled({ enableOnReady: true })
  useRunOnceReady(true, () => void events.gl_signup_open.fire())
  const { t } = useTranslation('group_life')

  return (
    <Layout header={<BlankTopNavigation logoUrl="/goodtrust-life" />}>
      <Block>
        <SWrapper>
          <Stack space={'1.5rem'}>
            <Title variant={Title_h1_default} as="h1">
              {t('group_life.signup_page.title')}
            </Title>

            <Stack gap="1rem">
              <Caption>{t('group_life.signup_page.membership_includes_caption')}</Caption>

              <HStack>
                <IconWrapper iconColor={colors.blue[500]} backgroundColor={colors.blue[100]}>
                  <Icon name="LifeInsurance" />
                </IconWrapper>
                <Text variant={'bodyLargeBold'} css={{ fontSize: '1.5rem' }} color="black">
                  {t('group_life.signup_page.coverage', { amount: `$${formatPrice(50000)}` })}
                </Text>
              </HStack>

              <HStack>
                <IconWrapper
                  iconColor={colors.orange[200]}
                  backgroundColor={'rgba(236, 140, 69, 0.2)'}
                >
                  <Icon name="Will" />
                </IconWrapper>
                <Text variant={'bodyLargeBold'} css={{ fontSize: '1.5rem' }} color="black">
                  {t('group_life.signup_page.estate_plus', { amount: `$${formatPrice(50000)}` })}
                </Text>
              </HStack>
            </Stack>

            <SList>
              {t('group_life.signup_page.perks', { returnObjects: true })?.map((perk) => (
                <SListItem key={perk}>
                  <Icon name="CheckSimple" size="1rem" color={colors.blue[500]} />
                  <Text>{perk}</Text>
                </SListItem>
              ))}
            </SList>

            <hr
              css={css`
                width: 100%;
                background: ${colors.blue[100]};
                height: 1px;
                border: none;
              `}
            />

            {isGroupLifeAvailable() && (
              <HStack
                css={css`
                  justify-content: space-between;
                `}
              >
                <Text>{t('group_life.signup_page.carried_by')}</Text>
                <AmalgamatedAgencyLogo />
              </HStack>
            )}
          </Stack>

          <GroupLifeSignupForm />
        </SWrapper>
      </Block>
    </Layout>
  )
}
